import { Button, InputAndButtons } from '@Knowledge-OTP/znk-ui-components'
import React, { useState } from 'react'
import useTranslation from '../../../i18n/useTranslation'

const PendingLessonsInner = (props) => {
    const { translate } = useTranslation()
    const { setLessonsPending } = props

    const [hover, setHover] = useState(false)
    const [input, setInput] = useState({ total: 0 })

    const cancel = () => {
        setHover(!hover)
        setLessonsPending(0)
    }
    return (
        <div className='pending-lessons-panel'>
              <div className='pending-lessons-inner'>
                <div className='d-flex flex-column'>
                  <h2 style={{'font-size':'15px', color:'#2c3f58'}}>{translate("filters.plans.pendingLessonsTitle")}</h2>
                  <h2 style={{'font-size':'15px', color:'#2c3f58'}}>{translate('filters.plans.quantityLessons')}</h2>
                </div>
                <InputAndButtons
                  form={input}
                  setForm={setInput}
                  inputName='total'
                  // title={translate('filters.plans.quantityLessons')}
                />
              </div>
              {/* <div className={`borderTop w-100`} /> */}
              <div className='d-flex flex-row text-center w-100 text-gray align-items-center justify-content-center'>
                <label  abel className={`tex-gray`} style={{"font-size": "12px", color:  "#778699"}}>Matches plans with this many or more.</label>
              </div>
              <div className={`pending-lessons-actions d-flex flex-row justify-content-end pb-1`}>
                <Button
                  className='button-cancel w-auto text-secondary'
                  size='small'
                  color=''
                  style={{ height: '32px', fontSize: '13px', padding: '0 15px', fontWeight: '500' }}
                  label={translate('filters.plans.buttonCancel')}
                  onClick={() => cancel()}
                  type='button'
                />
                <Button
                  className='button-submit w-auto'
                  size='small'
                  color='primary'
                  style={{ height: '32px', fontSize: '13px', padding: '0 15px', fontWeight: '500' }}
                  label={translate('filters.plans.buttonApply')}
                  onClick={() => setLessonsPending(input.total)}
                  type='button'
                />
              </div>
              {/* <ListItem
                className='px-5 h45'
                showTopLine
                Left={
                  <Button
                    className='h45 pl-0 py-0 ml-0 w-auto button-cancel text-secondary font-weight-normal'
                    label={translate('filters.plans.buttonCancel')}
                    onClick={() => cancel()}
                  />
                }
                Right={
                  <Button
                    className='h45 pr-0 py-0 mr-0 w-auto button-submit text-primary font-weight-normal'
                    label={translate('filters.plans.buttonApply')}
                    onClick={() => setLessonsPending(input.total)}
                    type='submit'
                  />
                }
              /> */}
        </div>
    )
}

export default PendingLessonsInner
